import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import BackgroundPicker from 'lib/ui/form/BackgroundPicker'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'
import {DEFAULT_BUTTON_BACKGROUND_COLOR} from 'lib/ui/Button/CustomButton'
import {WidgetButton} from 'organization/Event/WidgetConfig/ButtonStylesConfig/WidgetButton'

export default function BackgroundSection(props: {
  control: UseFormMethods['control']
  button: WidgetButton
  storageKey: string
}) {
  const {control, button} = props

  return (
    <CollapsibleSection label="Background" storageKey={props.storageKey}>
      <Controller
        name="backgroundColor"
        control={control}
        defaultValue={button.backgroundColor || DEFAULT_BUTTON_BACKGROUND_COLOR}
        render={({value, onChange}) => (
          <BackgroundPicker
            label="Background"
            background={value}
            onChange={onChange}
          />
        )}
      />
      <Controller
        name="hoverBackgroundColor"
        control={control}
        defaultValue={
          button.hoverBackgroundColor || DEFAULT_BUTTON_BACKGROUND_COLOR
        }
        render={({value, onChange}) => (
          <BackgroundPicker
            label="Hover Background"
            background={value}
            onChange={onChange}
          />
        )}
      />
    </CollapsibleSection>
  )
}
